import { useCallback, useState } from "react";
import { deleteSurvey } from "../api/survey.api";
import { useResultHandler } from "../../../../hooks/useResultHandler";
import { useToast } from "../../../../components";
import { ResultCode } from "../../../../lib/result-codes";
export const useDeleteSurvey = () => {
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const { handleResult } = useResultHandler();

  const deleteSurveyRequest = useCallback(async (id: string) => {
    try {
      setLoading(true);
      const response = await deleteSurvey(id);
      handleResult(response, {
        edgeCases: {
          [ResultCode.Success]: () => {
            addToast({
              type: "success",
              title: "Success!",
              message: "Survey has been deleted successfully",
            });
          },
          [ResultCode.SurveyPublishedCannotDelete]: () => {
            addToast({
              type: "warning",
              title: "Cannot Delete Survey",
              message: "Published surveys cannot be deleted.",
            });
          },

          [ResultCode.SurveyHasResponsesCannotDelete]: () => {
            addToast({
              type: "warning",
              title: "Cannot Delete Survey",
              message: "This survey cannot be deleted because it already has responses.",
            });
          },
        },
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, handleResult]);

  return { deleteSurvey: deleteSurveyRequest, isDeleting: loading };
};

export type UseDeleteSurveyReturn = ReturnType<typeof useDeleteSurvey>;
